module.exports = __webpack_public_path__ + "img/servis-government.ca85e5f0.svg";